import {Role} from 'types';

const roles: {value: Role; label: string; description: string}[] = [
  {
    value: 'tech',
    label: 'Operations',
    description: 'prepare orders to be "Ready for Dispatch"',
  },
  // {value: 'driver', label: 'Driver - execute delivery (driver app)'},
  {
    value: 'dispatcher',
    label: 'Dispatch',
    description: 'assemble field team and organize routes',
  },
  {
    value: 'management',
    label: 'Manager',
    description: 'control access, billing plan, and view whole system',
  },
  {
    value: 'customer_service',
    label: 'Customer Service',
    description: 'confirms details and payment',
  },
  {
    value: 'landlord',
    label: 'Landlord',
    description: 'manage properties, tenants and jobs',
  },
];

export const ROLES_LABELS: Record<Role, string> = {
  tech: 'Operations',
  dispatcher: 'Dispatch',
  management: 'Manager',
  customer_service: 'Customer Service',
  landlord: 'Landlord',
  driver: 'Driver',
  front_desk: 'Front Desk',
  customer: 'Customer',
  superuser: 'Superuser',
};

export default roles;
